import { AUTUMN, SPRING, SUMMER, WINTER } from "./consts";

import { Plant } from "./model";
import gcd from "gcd";
import { plants } from "./config";

export const formatSeasons = (seasons: number, isMonospace = false) => {
  let str = [];

  if (seasons & AUTUMN) {
    str.push("Autumn");
  } else {
    isMonospace && str.push("      ");
  }

  if (seasons & WINTER) {
    str.push("Winter");
  } else {
    isMonospace && str.push("      ");
  }

  if (seasons & SPRING) {
    str.push("Spring");
  } else {
    isMonospace && str.push("      ");
  }

  if (seasons & SUMMER) {
    str.push("Summer");
  } else {
    isMonospace && str.push("      ");
  }

  return str.join(", ");
};

/**
 * Returns the smallest possible recipe (in terms of length), that can be used to generate
 * the recipee that was supplied.
 * @param recipe
 */
export const getRecipeCore = (recipe: Plant[]) => {
  const plantCount = recipe.reduce(
    (agg, next) => ({ ...agg, [next.name]: (agg[next.name] || 0) + 1 }),
    {} as { [key: string]: number }
  );
  const div = Object.values(plantCount)
    .filter((i) => i > 0)
    .reduce((agg, next) => gcd(agg, next));

  if (div === 1) return recipe;

  const uniqRecipe = [] as Plant[];
  Object.entries(plantCount).forEach(([name, occurance]) => {
    const plant = plants.find((p) => p.name === name) as Plant;

    for (let i = 0; i < occurance / div; i++) {
      uniqRecipe.push(plant);
    }
  });

  return uniqRecipe;
};
